import styled from 'styled-components';

import {colors} from '@app/styles/theme';

export const Form = styled.form`
    padding: 0 24px 24px;
    text-align: left;
`;

export const FormDescription = styled.p`
    margin: 0 0 20px;
    font-size: 14px;
    line-height: 1.4;
    color: ${colors.textSecondary};
`;

export const FormGrid = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const Row = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 16px;

    & > * {
        flex: 1;
        min-width: 140px;
    }
`;

export const ButtonRow = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-top: 8px;
    padding-top: 8px;
`;
